<template>
    <table>
        <tr>
            <td v-for="rating in [1,2,3,4,5]" class="adjust" :key="rating" >
                <img v-if="isFull(rating)" src="../../assets/images/svg/icone_stella-piena.svg" :height="size"/>
                <img v-else src="../../assets/images/svg/icone_stella-vuota.svg" :height="size"/>
            </td>
        </tr>
    </table>
</template>

<script>
export default {
  name: 'RatingStars',
  props: {
    size: {
      type: String,
      default: '16px'
    },
    value: {
      type: Number,
      default: 3
    }
  },
  methods: {
    isFull (rating) {
      return this.value >= rating
    }
  }
}
</script>

<style scoped>
    .adjust {
        line-height: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/front/components/common/RatingStars.vue